import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const StaffPrintPagesLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'StaffPrintPages' */ './components/StaffPrintPages'
		)
);

export default (store) => {
	return {
		path: 'staff-setup/:campusId?/print-pages',
		element: (
			<AsyncLoading
				component={<StaffPrintPagesLazy permission="CanViewAdmissionSetup" />}
			/>
		),
	};
};
